// export default IncidentRequest;
import React, { useState } from "react";
import BackButton from "components/BackButton";
import PrivateProsecutionList from "./PrivateProsecutionList";
import PrivateProsecutionDetail from "./PrivateProsecutionDetail";
import { InvestigationFile } from "types";

type Props = {
  file: InvestigationFile;
  crimeReferenceNumber?: string;
  incidentRegistrationNumber?: string;
};

const PrivateProsecutionTab: React.FC<Props> = ({
  file,
  crimeReferenceNumber,
  incidentRegistrationNumber,
}) => {
  const [pageType, setPageType] = useState<"list" | "detail">("list");
  const [selectedId, setSelectedId] = useState<string | number>("");

  return (
    <div>
      {pageType === "list" ? (
        <PrivateProsecutionList
          file={file}
          crimeReferenceNumber={crimeReferenceNumber}
          incidentRegistrationNumber={incidentRegistrationNumber}
          setSelectedId={setSelectedId}
          setPageType={setPageType}
        />
      ) : (
        <div>
          <BackButton onClick={() => setPageType("list")} />
          <PrivateProsecutionDetail selectedId={selectedId} />
        </div>
      )}
    </div>
  );
};

export default PrivateProsecutionTab;
